[
  {
    "id": "fall_of_rome",
    "characters": {
      "sculptor_fallofrome": {
        "ability": "You start knowing a player. Each night*, you learn the alignment of their most recent nomination.",
        "homebrew": {
          "name": "Sculptor",
          "roleType": "townsfolk",
          "firstNightIndex": 21,
          "otherNightsIndex": 19
        },
        "firstNight": "Point to a player. Place the SCULPTURE token next to that player.",
        "otherNights": "If the player with the SCULPTURE token nominated today. Show the Sculptor an evil thumbs down sign if the nominated player is evil. Otherwise: show the Sculptor a good thumbs up sign. Remove the NOMINATED token (if any)."
      },
      "vestalvirgin_fallofrome": {
        "ability": "You start knowing 1 good & 1 evil character, 1 of which is in-play. When they die, that night you learn 1 good & 1 evil character, 1 of which is in-play.",
        "homebrew": {
          "name": "Vestal Virgin",
          "roleType": "townsfolk",
          "firstNightIndex": 22,
          "otherNightsIndex": 20
        },
        "firstNight": "Show 1 good and 1 evil character token: one of these is in play. Place the LEARNS next to the in-play character. ",
        "otherNights": "If the player with the LEARNS token died today, remove the token. Show 1 good and 1 evil character token: one of these is in play. Place the LEARNS next to the in-play character. "
      },
      "physician_fallofrome": {
        "ability": "Each night, choose two players (not yourself): they are sober, healthy & get true info tonight. The 1st time the Demon kills one, you learn the Demon type.",
        "homebrew": {
          "name": "Physician",
          "roleType": "townsfolk",
          "firstNightIndex": 20,
          "otherNightsIndex": 11
        },
        "firstNight": "The Physician points to two players not themselves. Mark both players with the PATIENT token.",
        "otherNights": "Remove all PATIENT tokens. The Physician points to two players not themselves. Mark both players with the PATIENT token. If a player with a PATIENT token was killed by the Demon, place the 1ST DEMON token next to the Physician and wake the Physician and show them Demon token."
      },
      "legionary_fallofrome": {
        "ability": "Each night, you learn how many living evil players are sat clockwise between yourself and a living Legionary. [+0 to +2 Legionary]",
        "homebrew": {
          "name": "Legionary",
          "roleType": "townsfolk",
          "firstNightIndex": 23,
          "otherNightsIndex": 21
        },
        "firstNight": "Show the hand signal for the number (0, 1, 2, etc.) of living evil players between the Legionary and the next clockwise Legionary (exclusive).",
        "otherNights": "Show the hand signal for the number (0, 1, 2, etc.) of living evil players between the Legionary and the next clockwise Legionary (exclusive)."
      },
      "trumpeter_fallofrome": {
        "ability": "Each night*, you learn how many evil players publicly claimed to be Spartacus today.",
        "homebrew": {
          "name": "Trumpeter",
          "roleType": "townsfolk",
          "otherNightsIndex": 22
        },
        "otherNights": "Show the hand signal for the number (0, 1, 2, etc.) of evil players who publicly claimed to be Spartacus today."
      },
      "mortician_fallofrome": {
        "ability": "Each night*, if a player died by execution today you learn if either of their living neighbours are evil.",
        "homebrew": {
          "name": "Mortician",
          "roleType": "townsfolk",
          "otherNightsIndex": 23
        },
        "otherNights": "If a player was executed today: Show the head signal (nod 'yes', shake 'no') for whether one of the neighbours is evil."
      },
      "standardbearer_fallofrome": {
        "ability": "When you are nominated, you may make a unique public statement about the nominator (not yourself). Tonight, you learn if the statement was true.",
        "homebrew": {
          "name": "Standard Bearer",
          "roleType": "townsfolk",
          "otherNightsIndex": 24
        },
        "otherNights": "If the Standard Bearer's public statement was true: show the head signal (nod 'true'). Otherwise: show the head signal (shake 'false')."
      },
      "centurion1_fallofrome": {
        "ability": "If you nominate & execute a living player, their team loses. You are safe from the Demon. If you publicly claimed to be Spartacus today, you are drunk until dawn.",
        "homebrew": {
          "name": "Centurion",
          "roleType": "townsfolk"
        }
      },
      "merchant_fallofrome": {
        "ability": "Once per game, at night, choose to learn the characters of players that have nominated you.",
        "homebrew": {
          "name": "Merchant",
          "roleType": "townsfolk",
          "otherNightsIndex": 26
        },
        "otherNights": "If the Merchant has not yet used their ability: the Merchant either shows a shake 'no' head signal, or a nod 'yes' head signal. If the Merchant chose 'yes', show the character tokens of players with a NOMINATED token (in any order). Place the NO ABILITY token."
      },
      "gladiator_fallofrome": {
        "ability": "Once per game, during the day, publicly choose a living player. Tonight, you and they wake & silently play roshambo: whoever loses dies (someone must lose).",
        "homebrew": {
          "name": "Gladiator",
          "roleType": "townsfolk",
          "otherNightsIndex": 18
        },
        "otherNights": "If the Gladiator used their ability today wake the Gladiator and the player they chose: both players silently play roshambo (rock \"fist\", scissors \"two fingers\" or paper \"flat hand\"). If they both chose the same, play again. Play until someone wins. The loser dies."
      },
      "actor_fallofrome": {
        "ability": "Once per game, during the day, publicly guess 3 players' character types (not yourself, 1 guess per type). That night, you learn how many you got correct. ",
        "homebrew": {
          "name": "Actor",
          "roleType": "townsfolk",
          "otherNightsIndex": 25
        },
        "otherNights": "If the Actor used their ability today: Show the hand signal for the number (0, 1, 2, or 3) of CORRECT markers. Place the NO ABILITY marker."
      },
      "blacksmith_fallofrome": {
        "ability": "The 1st time the Demon kills you, you live & gain a not-in-play Townsfolk ability.",
        "homebrew": {
          "name": "Blacksmith",
          "roleType": "townsfolk",
          "otherNightsIndex": 17
        },
        "otherNights": "If the Blacksmith was killed by a Demon. Show the Blacksmith a not-in-play Townsfolk character token. Swap the not-in-play character token with the Blacksmith token. Place the IS THE BLACKSMITH token next to the not-in-play character token. Wake the Blacksmith and show 'You are', then their new character ability."
      },
      "scholar_fallofrome": {
        "ability": "The 1st time you nominate a living Outsider, they immediately become a not-in-play Townsfolk. [+1 Outsider]",
        "homebrew": {
          "name": "Scholar",
          "roleType": "townsfolk",
          "otherNightsIndex": 2
        },
        "otherNights": "If the Scholar nominated an Outsider today, place the NO ABILITY token. Wake the nominated player. Show 'You are', then their new character token."
      },
      "thetwins_fallofrome": {
        "ability": "You start knowing a player: if either of you are executed, all Townsfolk are drunk until dusk tomorrow.",
        "homebrew": {
          "name": "The Twins",
          "roleType": "outsider",
          "firstNightIndex": 19,
          "otherNightsIndex": 10
        },
        "firstNight": "Point to a player. Place the REMUS token next to that player.",
        "otherNights": "If The Twins has a TOWNSFOLK DRUNK token, all Townsfolk are drunk until dusk."
      },
      "winemaker_fallofrome": {
        "ability": "Your Townsfolk neighbours are drunk, but every other night, you are drunk until dusk, even if you are dead.",
        "homebrew": {
          "name": "Winemaker",
          "roleType": "outsider",
          "firstNightIndex": 18,
          "otherNightsIndex": 9
        },
        "firstNight": "Place either the ODD or EVEN token. If ODD, the Winemaker is drunk on the 1st night and every other night after. Otherwise: the Winemaker is drunk on the 2nd night and every other night after.",
        "otherNights": "Check which ODD or EVEN token is placed. If an odd night and the ODD token is placed, the Winemaker is drunk until dusk. If an even night and the EVEN token is placed, the Winemaker is drunk until dusk. Otherwise their Townsfolk neighbours are drunk until dusk."
      },
      "spartacus_fallofrome": {
        "ability": "If an evil player guesses you (once), your team loses. You might register as a Townsfolk; each day, if you did not publicly claim to be Spartacus, you don't.",
        "homebrew": {
          "name": "Spartacus",
          "roleType": "outsider"
        }
      },
      "badomen_fallofrome": {
        "ability": "You do not know you are a Bad Omen. You think you are a Townsfolk, but you receive false information. You might register as evil, even if dead.",
        "homebrew": {
          "name": "Bad Omen",
          "roleType": "outsider"
        }
      },
      "temptress_fallofrome": {
        "ability": "On your 1st night choose two players: they learn that they were chosen. The 1st time one of them dies by execution, the other becomes evil that night.",
        "homebrew": {
          "name": "Temptress",
          "roleType": "minion",
          "firstNightIndex": 15,
          "otherNightsIndex": 3
        },
        "firstNight": "The Temptress points to two players. Place the SEDUCED token next to the two players. Wake the two players separately. Show the 'This character selected you' card, then the Temptress token. ",
        "otherNights": "If a player with a SEDUCED token is executed and dies, remove their SEDUCED token. The player with the remaining SEDUCED turns evil. Remove their SEDUCED token and replace it with the EVIL token. Wake the evil player and show them the 'You are' card and the thumbs down evil signal."
      },
      "haruspex_fallofrome": {
        "ability": "Each night, choose a player: you learn their character. The 1st player you choose twice in this way, dies. [+ Spartacus]",
        "homebrew": {
          "name": "Haruspex",
          "roleType": "minion",
          "firstNightIndex": 17,
          "otherNightsIndex": 16
        },
        "firstNight": "The Haruspex points to a player. Show that player’s character token. Place a FORETOLD token next that player. ",
        "otherNights": "The Haruspex points to a player. Show that player’s character token. Place a FORETOLD token next that player: if that player already has a FORETOLD token. That player dies, also place the CAN'T KILL token next to the Haruspex."
      },
      "glykon1_fallofrome": {
        "ability": "You might register as good. Until dawn, players you nominate register as the opposing alignment & if a Townsfolk, are also poisoned.",
        "homebrew": {
          "name": "Glykon",
          "roleType": "minion"
        }
      },
      "augur_fallofrome": {
        "ability": "If a Townsfolk nominates you, they immediately become a Bad Omen.",
        "homebrew": {
          "name": "Augur",
          "roleType": "minion"
        }
      },
      "cleopatra_fallofrome": {
        "ability": "Each night, choose two players: if they nominate tomorrow, they die that night. Each day, if a good player (Travellers don't count) does not nominate, evil wins. ",
        "homebrew": {
          "name": "Cleopatra",
          "roleType": "demon",
          "firstNightIndex": 16,
          "otherNightsIndex": 12
        },
        "firstNight": "Cleopatra points to two players. ",
        "otherNights": "If a previously chosen player nominated today they die. Remove all CHOSEN tokens. Cleopatra points to two players. Place the CHOSEN token next to both players."
      },
      "crassus_fallofrome": {
        "ability": "Each night*, choose a player: they die. If the 1st Crassus publicly claims to be Spartacus & dies with 5 or more players alive, an evil player becomes Crassus.",
        "homebrew": {
          "name": "Crassus",
          "roleType": "demon",
          "otherNightsIndex": 13
        },
        "otherNights": "Crassus points to a player. That player dies. If the 1st Crassus publicly claimed to be Spartacus today and points to themselves (or was executed), with 5 or more players alive, replace the character of 1 evil player with a spare Crassus token. Show the 'You are' card, then the Crassus token. "
      },
      "hannibal_fallofrome": {
        "ability": "You think you are a good character, but you are not. Minions learn 3 bluffs. Each night*, a player might die. The 1st Hannibal to die, becomes good. [+1 Hannibal] ",
        "homebrew": {
          "name": "Hannibal",
          "roleType": "demon",
          "firstNightIndex": 14,
          "otherNightsIndex": 14
        },
        "firstNight": "Select 2 good players and place the IS HANNIBAL reminder tokens. Wake all Minions together, show them the Hannibals and show them three not-in-play character tokens (these must be the same).",
        "otherNights": "Choose a player, that player dies. If a Hannibal died today, wake that player and show them the 'You are' card, the Hannibal token and then the thumbs up good signal."
      },
      "caesar_fallofrome": {
        "ability": "Each night*, choose a player: they die. The 1st time an evil player dies by execution, that night, choose an additional player: they die.",
        "homebrew": {
          "name": "Caesar",
          "roleType": "demon",
          "otherNightsIndex": 15
        },
        "otherNights": "If an evil player was executed today, Caesar points to two players. Otherwise: Caesar points to a player. Chosen players die."
      },
      "mercenary_fallofrome": {
        "ability": "Each night*, gain the ability of a player who publicly claimed Spartacus today. If a Mercenary is exiled, you are exiled too. [+1 Mercenary of opposing alignment]",
        "homebrew": {
          "name": "Mercenary",
          "roleType": "travellers",
          "otherNightsIndex": 4
        },
        "otherNights": "Show the Mercenary a character that publicly claimed to be Spartacus today, they have that ability tonight and tomorrow until dusk. "
      },
      "architect_fallofrome": {
        "ability": "Each night*, choose a player: 1) they become a not-in-play character of the same type, or 2) they swap characters with a player of the same type.",
        "homebrew": {
          "name": "Architect",
          "roleType": "travellers",
          "otherNightsIndex": 7
        },
        "otherNights": "The Architect points to a player. Choose which ability will effect the chosen player. Treat them accordingly (not-in-play character or character swap). Wake affected players individually. Show 'You are', then their new character token."
      },
      "sibyl_fallofrome": {
        "ability": "Each day, after the 1st execution, you may publicly choose a dead player: they may nominate. If the majority of the dead and yourself agree, they are executed.",
        "homebrew": {
          "name": "Sibyl",
          "roleType": "travellers"
        }
      },
      "highpriest1_fallofrome": {
        "ability": "Each day, publicly choose a unique living player to bless: if a majority of players agree, something good happens to them.",
        "homebrew": {
          "name": "High Priest",
          "roleType": "travellers",
          "otherNightsIndex": 5
        },
        "otherNights": "If the High Priest successfully blessed a player today, something good happens to that player and/or their team."
      },
      "highpriest2_fallofrome": {
        "ability": "Each day, publicly choose a unique living player to bless: if a majority of players agree, tomorrow they may learn a statement. Tonight, choose if it’s true.",
        "homebrew": {
          "name": "High Priest",
          "roleType": "travellers",
          "otherNightsIndex": 6
        },
        "otherNights": "If the High Priest successfully blessed a player today, wake the High Priest. The High Priest chooses whether the statement is true tomorrow with a hand signal (true \"thumbs up\", false \"thumbs down\")."
      },
      "emperor_fallofrome": {
        "ability": "Each day, choose the 1st execution's outcome. If you choose to protect today's execution: they survive. Otherwise, tonight you learn their alignment.",
        "homebrew": {
          "name": "Emperor",
          "roleType": "travellers",
          "otherNightsIndex": 8
        },
        "otherNights": "If a player was executed today and the outcome was not overturned by the Emperor: Show the hand signal (thumbs down 'evil', thumbs up 'good') for the players alignment."
      },
      "iamspartacus_fallofrome": {
        "ability": "Each day, up to half the living players (rounded up & Travellers don’t count) may publicly claim to be Spartacus.",
        "homebrew": {
          "name": "I Am Spartacus!",
          "roleType": "fabled"
        }
      }
    },
    "script": {
      "pk": 24823,
      "title": "Fall of Rome",
      "author": "Alex S",
      "score": 0,
      "characters": [
        "sculptor_fallofrome",
        "vestalvirgin_fallofrome",
        "physician_fallofrome",
        "legionary_fallofrome",
        "trumpeter_fallofrome",
        "mortician_fallofrome",
        "standardbearer_fallofrome",
        "centurion1_fallofrome",
        "merchant_fallofrome",
        "gladiator_fallofrome",
        "actor_fallofrome",
        "blacksmith_fallofrome",
        "scholar_fallofrome",
        "thetwins_fallofrome",
        "winemaker_fallofrome",
        "spartacus_fallofrome",
        "badomen_fallofrome",
        "temptress_fallofrome",
        "haruspex_fallofrome",
        "glykon1_fallofrome",
        "augur_fallofrome",
        "cleopatra_fallofrome",
        "crassus_fallofrome",
        "hannibal_fallofrome",
        "caesar_fallofrome",
        "mercenary_fallofrome",
        "architect_fallofrome",
        "sibyl_fallofrome",
        "highpriest1_fallofrome",
        "highpriest2_fallofrome",
        "emperor_fallofrome",
        "iamspartacus_fallofrome"
      ]
    }
  }
]